import React from "react";
import { Link } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function CartItem({ item }) {
  const { updateQuantity, removeFromCart } = useCart();
  const { product, quantity } = item;
  if (!product) return null;

  return (
    <div
      data-testid={`cart-item-${product.slug}`}
      className="flex gap-4 md:gap-6 p-4 md:p-6 bg-white border border-brand-line rounded-2xl"
    >
      <Link to={`/products/${product.slug}`} className="shrink-0">
        <div className="w-24 h-24 md:w-32 md:h-32 bg-brand-sand rounded-xl overflow-hidden">
          <img
            src={product.images?.[0]}
            alt={product.name}
            className="w-full h-full object-cover"
          />
        </div>
      </Link>
      <div className="flex-1 min-w-0">
        <div className="flex justify-between gap-2">
          <div>
            <p className="text-[11px] uppercase tracking-wider text-brand-moss font-bold">
              {product.pack_size}
            </p>
            <Link to={`/products/${product.slug}`}>
              <h3 className="font-heading font-bold text-lg md:text-xl text-brand-ink hover:text-brand-orange">
                {product.name}
              </h3>
            </Link>
            <p className="font-heading font-black text-lg mt-1 text-brand-ink">
              ₹{product.price}
            </p>
          </div>
          <button
            onClick={() => removeFromCart(product.id)}
            data-testid={`remove-item-${product.slug}`}
            className="text-brand-moss hover:text-brand-orange p-1 shrink-0"
            aria-label="Remove"
          >
            <Trash2 size={18} />
          </button>
        </div>
        <div className="flex items-center justify-between mt-4">
          <div className="inline-flex items-center bg-brand-cream rounded-xl border border-brand-line">
            <button
              data-testid={`qty-decrement-${product.slug}`}
              onClick={() => updateQuantity(product.id, quantity - 1)}
              className="w-9 h-9 flex items-center justify-center hover:text-brand-orange"
            >
              <Minus size={14} />
            </button>
            <span
              data-testid={`qty-value-${product.slug}`}
              className="w-8 text-center font-bold"
            >
              {quantity}
            </span>
            <button
              data-testid={`qty-increment-${product.slug}`}
              onClick={() => updateQuantity(product.id, quantity + 1)}
              className="w-9 h-9 flex items-center justify-center hover:text-brand-orange"
            >
              <Plus size={14} />
            </button>
          </div>
          <p className="font-heading font-black text-xl text-brand-ink">
            ₹{(product.price * quantity).toFixed(0)}
          </p>
        </div>
      </div>
    </div>
  );
}
